// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__arounder_370be3', '__arounder_Fallback_370be3', Roboto, sans-serif"},"className":"__className_370be3"};